(function () {
  function init() {
    var stage = document.getElementById('gwb-stage');
    var dataEl = document.getElementById('gwb-data');
    if (!stage || !dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent) || {}; } catch (e) { return; }

    var decors = data.decors || {};
    var foregrounds = data.foregrounds || {};

    var index = [];
    for (var key in foregrounds) {
      if (!foregrounds[key] || !decors[key]) continue;
      index.push({ nom: key, decor: String(decors[key]).split('?')[0], fg: foregrounds[key] });
    }
    if (!index.length) return;

    var photoLayer = document.getElementById('gwb-custom-photo-layer');

    function retirer() {
      stage.style.removeProperty('--scene-foreground');
      stage.removeAttribute('data-scene-fg');
    }

    function apply() {
      if (photoLayer && !photoLayer.hasAttribute('hidden')) {
        retirer();
        return;
      }
      var current = stage.style.getPropertyValue('--scene-image') || '';
      for (var i = 0; i < index.length; i++) {
        if (current.indexOf(index[i].decor) !== -1) {
          stage.style.setProperty('--scene-foreground', "url('" + index[i].fg + "')");
          stage.setAttribute('data-scene-fg', index[i].nom);
          return;
        }
      }
      retirer();
    }

    apply();

    if (typeof MutationObserver === 'function') {
      new MutationObserver(apply).observe(stage, { attributes: true, attributeFilter: ['style'] });
      if (photoLayer) {
        new MutationObserver(apply).observe(photoLayer, { attributes: true, attributeFilter: ['hidden'] });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();